import { useTranslation } from "react-i18next";

export default function EditorialPolicy() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-custom max-w-4xl mx-auto text-center">
        <span className="inline-block px-5 py-2 rounded-full border border-foreground-300 text-xs md:text-sm font-medium text-foreground-600 mb-6 whitespace-nowrap">
          {t("home:editorialTag", "Our Editorial Policy")}
        </span>
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light text-foreground-900 leading-tight mb-8">
          <span className="inline-flex items-baseline gap-3">
            Manually Reviewed
            <span className="inline-block w-8 h-8 md:w-10 md:h-10">
              <i className="ri-check-double-line text-primary-500 text-2xl md:text-3xl"></i>
            </span>
          </span>
          <br />
          <span className="inline-flex items-baseline gap-3">
            Weekly Updated
            <span className="inline-block w-8 h-8 md:w-10 md:h-10">
              <i className="ri-refresh-line text-accent-500 text-2xl md:text-3xl"></i>
            </span>
          </span>
          <br />
          <span className="inline-flex items-baseline gap-3">
            Buyer First
            <span className="inline-block w-8 h-8 md:w-10 md:h-10">
              <i className="ri-heart-line text-primary-500 text-2xl md:text-3xl"></i>
            </span>
          </span>
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          {t("home:editorialDesc", "Every link in our spreadsheet directory is independently researched and verified. We never accept payments for listings, and our recommendations are based solely on product quality, seller reliability, and buyer satisfaction.")}
        </p>
      </div>
    </section>
  );
}